import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import {reducers} from './syncReducers'
import { gerenciaTecnicaState } from "./interfaces";


const initialState: gerenciaTecnicaState = {
  activeDepartmentId: undefined,
  showMenu: false,
  activeUser: undefined,
  loading: false,
  showUserMenu: false,
  activeDepartment:undefined,
  usersList: [],
  notifications: [],
  activitiesWithCarts:[],
  cardsWithActivities: [],
  taskValidations: [],
  totalActivities: 0,
  reportsList: [],
  reportWithData: [],
  reportFilters:undefined,
  locationListFilter: undefined,
};

export const gerenciaTecnicaSlice = createSlice({
  name: "main",
  initialState,
  reducers,
});